import {
    Card, CardBody,
    Col, Modal,
    ModalBody,
    ModalHeader, Row
} from "reactstrap";
import React from "react";
import {formatModifyDate} from "../../../../../components/Common/CommonLogic";

const ModalFreightAirLocal = ({ viewData, modal, onCloseClick, modalType }) => {
    return (
        <>
            <Modal
                isOpen={modal}
                toggle={onCloseClick}
                className="table_view_modal"
                style={{ maxWidth: "1345px" }}>
                <ModalHeader tag="h4">
                    {modalType}
                    <span className="close" onClick={onCloseClick}></span>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        {/* Charge Category */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Charge Category</label>
                                            <span>{viewData?.surchargeCategory?.name}</span>
                                        </div>

                                        {/* Port Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">AirPort Name<span className='required_star'>*</span></label>
                                            <span>{viewData?.airPort?.name}</span>
                                        </div>

                                        {/* Terminal Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Terminal Name</label>
                                            <span>-</span>
                                        </div>

                                        {/* Movement Type */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Movement Type<span className='required_star'>*</span></label>
                                            <span>{viewData?.movementType}</span>
                                        </div>

                                        {/* Carrier Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Carrier Name<span className='required_star'>*</span></label>
                                            <span>{viewData?.carrierMaster?.name}</span>
                                        </div>

                                        {/* Vendor Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Agent Name</label>
                                            <span>-</span>
                                        </div>

                                        {/* Validity From */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Validity From<span className='required_star'>*</span></label>
                                            <span>{formatModifyDate(viewData?.validFrom)}</span>
                                        </div>

                                        {/* Validity To */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Validity To<span className='required_star'>*</span></label>
                                            <span>{formatModifyDate(viewData?.validTo)}</span>
                                        </div>
                                    </div>

                                    <hr />
                                    <div className="p-3"></div>
                                    <Card>
                                        <CardBody>
                                            {viewData?.vendorAirportChargeDetails?.map((chargeDetail, chargeIndex) => (
                                                <div className="row" key={`charge-${chargeIndex}`}>
                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Charge Code
                                                        </label>
                                                        <span>{chargeDetail?.surchargeCode?.description || ""}</span>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Charge Basis
                                                        </label>
                                                        <span>{chargeDetail?.unitOfMeasurement?.description || ""}</span>
                                                    </div>

                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Currency
                                                        </label>
                                                        <span>{chargeDetail?.currency?.currencyName || ""}</span>
                                                    </div>

                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">Tax (Optional)</label>
                                                        <span>{chargeDetail?.tax || ""}</span>
                                                    </div>
                                                    {chargeDetail?.vendorAirportChargeValues?.map((rate, rateIndex) => (
                                                        <Card key={`rate-${chargeIndex}-${rateIndex}`}>
                                                            <CardBody>
                                                                <div className="row">
                                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                                        <label className="form-label">
                                                                            Cargo Type
                                                                        </label>
                                                                        <span>{rate?.cargoType?.type || ""}</span>
                                                                    </div>

                                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                                        <label className="form-label">
                                                                            Min Value
                                                                        </label>
                                                                        <span>{rate?.minValue}</span>
                                                                    </div>

                                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                                        <label className="form-label">
                                                                            Rate
                                                                        </label>
                                                                        <span>{rate?.rate}</span>
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    ))}
                                                </div>
                                            ))}
                                        </CardBody>
                                    </Card>


                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ModalFreightAirLocal;
